import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";
export const paymentGatewayList = async (accessToken) => {
  try {
    const response = await axiosInstance.get("/ipgs/list", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message: error.response.data?.message || "خطای ناشناخته   ",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const charge = async ({ accessToken, gateway, amount }) => {
  try {
    const response = await axiosInstance.get(
      `/ipgs/${gateway}/charge/${amount}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message: error.response.data?.message || "خطای ناشناخته   ",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const customerCharge = async ({ accessToken, gateway, amount, businessId }) => {
  try {
    const response = await axiosInstance.post(
      `/ipgs/${gateway}/customer/charge/${amount}`,
      { businessId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const buyPlan = async ({
  accessToken,
  planId,
  mode,
  ipg,
  offerCode,
  autoRenewal,
  useWallet,
}) => {
  try {
    const response = await axiosInstance.post(
      "/business/plans/purchase",
      { planId, mode, ipg, offerCode, autoRenewal, useWallet },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status == 402) {
        toast.error("اعتبار شما کافی نمی باشد.")
      }
      else if (status == 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      */
      throw {
        statusCode: status,
        message: error.response.data?.message || "خطای ناشناخته   ",
      };
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
